export default __webpack_public_path__ + "static/media/logoIcon.fcf9a837.png";